import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {AppTemplateService} from "@catmodels/project-partnumbers/services/app-template.service";
import {Subscription} from "rxjs";
import {sortByLabelFunc} from "@catcore/utils";
import {NotificationsService, ProjectService} from "@catcore/services";
import {ConfirmationService} from "primeng/api";

@Component({
  selector: 'catapp-app-template-form',
  templateUrl: './app-template-form.component.html',
  styleUrls: ['./app-template-form.component.scss']
})
export class AppTemplateFormComponent implements OnInit, OnDestroy {

  private _projectAppSelections: any;

  form: FormGroup = null;

  staticTemplateOptions: any[] = [
    { value: null, label: "None" }
  ];
  templateOptions: any[] = [...this.staticTemplateOptions];
  templateSubscription: Subscription = null;

  @Output() afterUpdate = new EventEmitter();

  @Input() project;
  @Input() set projectAppSelections(value) {
    this._projectAppSelections = value;
    if (value._links.hasOwnProperty("app_template")) {
      this.form.patchValue({
        app_template: value._links.app_template.href
      });
    } else {
      this.form.patchValue({
        app_template: null
      });
    }
  }

  constructor(
    private appTemplateService: AppTemplateService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationsService,
    private confirmationService: ConfirmationService,
    private projectService: ProjectService
  ) {
    this.form = this.formBuilder.group({
      app_template: ['', []]
    });
  }

  ngOnInit() {
    this.templateSubscription = this.appTemplateService.getAll()
      .subscribe((appTemplates) => {
        this.templateOptions = [...this.staticTemplateOptions];
        appTemplates.forEach((appTemplate) => {
          this.templateOptions.push({
            value: appTemplate._links.self.href,
            label: appTemplate.name
          })
        });
        this.templateOptions.sort(sortByLabelFunc);
      });
  }

  ngOnDestroy(): void {
    if (this.templateSubscription) {
      this.templateSubscription.unsubscribe();
    }
  }

  onSubmit() {
    this.confirmationService.confirm({
      message: 'Changing the app template will reset all app selections. Do you want to proceed?',
      accept: () => {
        this.projectService.updateAppTemplate(this.project, this.form.value.app_template)
        .subscribe((result) => {
          this.notificationService.success('Template saved', 'Successfully updated the app template.');
          this.afterUpdate.emit();
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-partnumbers/components/app-template-form/app-template-form.component.ts